import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import styles from "./DesignBoxConfirmationPreviewPage.module.css";
import LinkSocialAppIcon from "../LinkSocialAppIcon";

const DesignBoxHopeToFix = () => {
  return (
    <>
      <Header />
      <div className={styles.hopeFixContainer}>
        <p>
          デザイン・配置等の変更希望の内容詳細を 必ず1週間以内にAcestudio
          Ofiicial LINEへご連絡ください。
          お送りいただいた内容をもとに、再度完成画像データを作成いたします。
        </p>
        <LinkSocialAppIcon />
      </div>
      <Footer />
    </>
  );
};

export default DesignBoxHopeToFix;
